import React from 'react';
import { INameSearchName } from '../types';
import Dropzone from 'react-dropzone';
import styled from '@emotion/styled';
import { FileUpload } from 'components/UploadCenter/UploadContin/types';
import { convertToBase64 } from 'lib/PublicFunctions';
interface IProps {
  contact: INameSearchName;
  removeFileFromContact: (contact: INameSearchName, fileIndex: number) => void;
  afterDropFile: (contact: INameSearchName, files: any[]) => void;
}

const DocumentOptions = styled.div`
  border: 1.4px dashed #e5e5ea;
  padding: 24px;
  border-radius: 4px;
  width: 250px;
`;
const UploadButton = styled.button`
  background-color: #333;
  border-radius: 5px;
  height: 40px;
  padding: 5px 16px;
  margin-right: 16px;
  border: none;
  width: 124px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  :hover {
    background-color: #444;
  }
`;

const FileList = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background-color: #f5f5f7;
  border-radius: 6px;
  border: 1px solid #e5e5ea;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ebebed;
  }
`;

const FileName = styled.span`
  flex: 1;
  font-size: 14px;
  color: #333;
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 18px;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #d9534f;
  }
`;

export default function Row(props: IProps) {
  const onDrop = async (newFiles: any) => {
    const arr: FileUpload[] = [];
    for (let file of newFiles) {
      const base64 = (await convertToBase64(file)) as string;
      const tempFile: FileUpload = {
        file: base64,
        actualFileName: file.name,
      };

      arr.push(tempFile);
    }

    props.afterDropFile(props.contact, arr);
  };

  return (
    <div style={{ border: '1px solid black', padding: 16 }}>
      <div style={{ fontWeight: 'bold', textAlign: 'center', textDecoration: 'underline' }}>
        {props.contact.name}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Dropzone onDrop={onDrop}>
          {({ getRootProps, getInputProps, isDragActive }) => {
            return (
              <DocumentOptions>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div style={{ textAlign: 'center' }}>
                    {isDragActive ? <span>drop here</span> : <span>Drag and drop files</span>}

                    <div style={{ color: '#e5e5ea', paddingTop: 8, paddingBottom: 8 }}>Or</div>
                    <UploadButton>Select File</UploadButton>
                  </div>
                </div>
              </DocumentOptions>
            );
          }}
        </Dropzone>
        <div>
          {props.contact.documents && props.contact.documents.length > 0 && (
            <FileList>
              {props.contact.documents.map((file, index) => (
                <FileItem key={index}>
                  <FileName>{file.actualFileName}</FileName>
                  <RemoveButton onClick={() => props.removeFileFromContact(props.contact, index)} title="Remove file">
                    ×
                  </RemoveButton>
                </FileItem>
              ))}
            </FileList>
          )}
        </div>
      </div>
    </div>
  );
}
